export default __webpack_public_path__ + "static/court-6a10fb262333b2e06ad63b6744180d66.jpg";